import { autocompleteClasses, inputClasses, outlinedInputClasses } from '@mui/material'
import { CSSObject } from 'tss-react'
import { gray, uiColors } from '~/common/styles/colors'
import { depth } from '~/common/styles/depths'
import { DropdownVariant } from './../types'

export const getAutocompleteBasePrimitives = (
  variant: DropdownVariant,
  isBorderless?: boolean,
): CSSObject => ({
  [`&.${autocompleteClasses.root}`]: {
    [`& .${autocompleteClasses.endAdornment}`]: {
      top: 'inherit',
      right: '12px',
    },
    [`&:hover .${autocompleteClasses.popupIndicator}`]: {
      backgroundColor: 'transparent',
    },
    [`& .${outlinedInputClasses.root}`]: {
      gap: '8px',
    },
    [`& .${outlinedInputClasses.root} .${autocompleteClasses.input}`]: {
      padding: variant === 'chip' ? '0px' : '0px 0px 0px 8px',
    },
  },
  [`& .${outlinedInputClasses.notchedOutline}`]: {
    border: isBorderless ? 'none' : `1px solid ${uiColors.border.normal}`,
    '&:hover': {
      border: isBorderless ? 'none' : `1px solid ${uiColors.border.hover}`,
    },
  },
  [`&:hover .${outlinedInputClasses.notchedOutline}`]: {
    border: isBorderless ? 'none' : `1px solid ${uiColors.border.hover}`,
  },
  [`.Mui-disabled .${outlinedInputClasses.notchedOutline}`]: {
    border: isBorderless ? 'none' : `1px solid ${uiColors.background.disabled}`,
  },
})

export const getDropdownBaseInputPrimitives = (readOnly: boolean, rounded: boolean): CSSObject => ({
  caretColor: readOnly ? 'transparent' : 'auto',
  [`& .${outlinedInputClasses.root}`]: {
    cursor: 'pointer',
  },
  [`& .${outlinedInputClasses.input}::selection`]: {
    backgroundColor: readOnly ? 'transparent' : gray[1],
  },
  borderRadius: rounded ? '.25rem' : undefined,
  [`& .${outlinedInputClasses.input}`]: {
    cursor: 'pointer',
    width: 'auto',
  },
  [`& .${inputClasses.multiline}`]: {
    flexWrap: 'wrap',
  },
})

export const dropdownMenuPrimitives: CSSObject = {
  borderRadius: '4px',
  border: `1px solid ${gray[4]}`,
  boxShadow: depth[2],
  [`& .${autocompleteClasses.listbox}`]: {
    padding: '0px',
  },
  '&[data-popper-reference-hidden]': {
    display: `none`,
    pointerEvents: 'none',
  },
}

export const dropdownChipPrimitives: CSSObject = {
  margin: '0px',
}

export const dropdownMenuItemPrimitives: CSSObject = {
  paddingInlineStart: '6px',
  paddingTop: '8px',
  paddingInlineEnd: '12px',
  paddingBottom: '8px',
}
